import { useState } from 'react';

export const useSelect = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);

  const toggle = event => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const close = () => {
    setAnchorEl(null);
  };

  const open = event => {
    setAnchorEl(event.currentTarget);
  };

  return { anchorEl, isOpen, close, open, toggle };
};
